import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filter-bar" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createElementBlock("button", {
        type: "button",
        key: option,
        onClick: _withModifiers(($event: any) => (_ctx.handleClick(option)), ["prevent"]),
        class: _normalizeClass(["btn-tab", { active: _ctx.active == option }])
      }, _toDisplayString(option === 0 ? "Lifetime" : (option === 1) ? "1 Year" : option + " Years"), 11, _hoisted_2))
    }), 128))
  ]))
}